export const Environment = {
  DEV: "development",
  STAGING: "staging",
  PROD: "production",
  NONE: "none",
};
